'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }



var _module = _angular2.default.module('cb.core.search.cb-search-results', []);

_module.directive('cbSearchResults', cbSearchResultsDirective);

exports.default = _module;


function cbSearchResultsDirective() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'searchResults',
        controller: 'cbSearchResultsController',
        template: "<gcse:searchbox gname=\"googlesearch\"></gcse:searchbox>\r\n<gcse:searchresults gname=\"googlesearch\" refinementStyle=\"link\" enableOrderBy=\"false\"></gcse:searchresults>\r\n"
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/search/cb-search-results.directive.js
// module id = 821
// module chunks = 0